import UiUtil from "../../../utils/UiUtil"
import ConnectLineType from "../../../viewmodel/datatype/ConnectLineType"
import MindElementShapeType from "../../../viewmodel/datatype/MindElementShapeType"
import MindType from "../../../viewmodel/datatype/MindType"
import DoubleBubbleMindNodeUnit from "../../../viewmodel/mindelementdata/DoubleBubbleMindNodeUnit"

import LineMindTypeNode from "../../../viewmodel/mindelementdata/LineMindTypeNode"
import LineMindTypeNodeUnit from "../../../viewmodel/mindelementdata/LineMindTypeNodeUnit"
import MindElementData from "../../../viewmodel/mindelementdata/MindElementData"
import TimeMindTypeNodeUnit from "../../../viewmodel/mindelementdata/TimeMindTypeNodeUnit"
import LineElementContent from "../../../viewmodel/mindelementdata/mindcontent/LineElementContent"
import HashMap from "../../../viewmodel/core/base/HashMap"
import Point from "../../../viewmodel/core/base/Point"
import Colors from "../../../utils/Colors"
import TextContent from "../../../viewmodel/mindelementdata/mindcontent/TextContent"
import Strings from "../../../utils/Strings"
import MindElementCalculation from "./elementCalculation/MindElementCalculation"
import CGPoint from "../../../viewmodel/core/base/basedata/CGPoint"
import NodeConnectLineHit from "./NodeConnectLineHit"
import strings from "../../../common/lang/strings"
import LinePointShape from "../../../viewmodel/datatype/LinePointShape"
import MindElementType from "../../../viewmodel/datatype/MindElementType"
import Util from "../../../utils/Util"
import PointAndTime from "../basemode/PointAndTime"
/**
 * ProjectName: MindMap
 * Created by tony on 2020/7/12
 * Copyright(c) 2020 mindyushu.com
 */

class NodeConnectLineCalcul {

    constructor() {
        this.MaxDeviationValue = new UiUtil().dip2px(10);
        this.MaxDistance = new UiUtil().dip2px(600);
        this.mainMindNodeUnit = new LineMindTypeNodeUnit(MindType.LINE_MAP, 0, false);
        this.freeNodes = new Array();
        this.nodeConnectLineDataDict = new HashMap(); //节点连接线
        this.timeMindTypeNodeUnit = new TimeMindTypeNodeUnit();
        this.doubleBubbleMindNodeUnit = new DoubleBubbleMindNodeUnit(MindType.DOUBLE_BUBBLE_MAP, 0);
        this.mindBGColor = 0x333333;
        this.lastClickPoint = new PointAndTime();
    }

    setData(mainMindNodeUnit, freeNodes, nodeConnectLineDataDict, timeMindTypeNodeUnit, doubleBubbleMindNodeUnit, mindBGColor, lastClickPoint) {
        this.mainMindNodeUnit = mainMindNodeUnit;
        this.freeNodes = freeNodes;
        this.nodeConnectLineDataDict = nodeConnectLineDataDict;
        this.timeMindTypeNodeUnit = timeMindTypeNodeUnit;
        this.doubleBubbleMindNodeUnit = doubleBubbleMindNodeUnit;
        this.mindBGColor = mindBGColor;
        this.lastClickPoint = lastClickPoint;
    }

    refreshNodeConnectLineLayout() {
        let keys = this.nodeConnectLineDataDict.keys();
        let length = keys.length
        for (let index = 0; index < length; index++) {
            let line = this.nodeConnectLineDataDict.get(keys[index]);
            this.setConnectLine(line)
        }
    }

    setConnectLine(line, isCheckControlPoint = true) {
        if (line == null || line.isEmpty()) {
            return
        }
        let target = this.getNodeById(line.parentNodeId).value;
        let to = this.getNodeById(line.lineContent.targetId).value;
        if (target.isEmpty() || to.isEmpty()) {
            return
        }
        let lineContent = line.lineContent;
        if (lineContent == null) {
            return;
        }
        this.initConnectLineControlPoint(line, target, to, isCheckControlPoint);
        let baseMargin = new UiUtil().dip2px(4);
        let targetMargin = 0;

        switch (lineContent.startShape) {
            case LinePointShape.NORMAL:
                targetMargin = 0;
                break;
            case LinePointShape.ARROW:
            case LinePointShape.BAMBOO_ARROW:
                targetMargin = new UiUtil().getArrowWidth(new Point( 0, 0), new Point( 0, 200), new UiUtil().dip2px(lineContent.lineWidth));
                break;
            case LinePointShape.SIMPLE_ARROW:
                targetMargin = new UiUtil().dip2px(1);
                break;
            case LinePointShape.CIRCULAR:
            case LinePointShape.CIRCULAR_HOLLOW:
                targetMargin = new UiUtil().dip2px(lineContent.lineWidth) * 2;
                break;
            case LinePointShape.CIRCULAR_RADIATION:
                targetMargin = new UiUtil().dip2px(lineContent.lineWidth) * 4;
                break;
            case LinePointShape.T_SHAPED:
                targetMargin = new UiUtil().dip2px(lineContent.lineWidth);
                break;
            case LinePointShape.DIAMOND:
                targetMargin = new UiUtil().dip2px(lineContent.lineWidth) * 2;
                break;
        }
        let startControlPoint = lineContent.getStartControlPoint();
        let targetI = target.getRightAngleShapeHitPoint(startControlPoint, (targetMargin + baseMargin));

        let arrowH = 0;

        switch (lineContent.endShape) {
            case LinePointShape.NORMAL:
                arrowH = 0;
                break;
            case LinePointShape.ARROW:
            case LinePointShape.BAMBOO_ARROW:
                arrowH = new UiUtil().getArrowWidth(new Point( 0, 0), new Point( 0, 200), new UiUtil().dip2px(lineContent.lineWidth));
                break;
            case LinePointShape.SIMPLE_ARROW:
                arrowH = new UiUtil().dip2px(1);
                break;
            case LinePointShape.CIRCULAR:
            case LinePointShape.CIRCULAR_HOLLOW:
                arrowH = new UiUtil().dip2px(lineContent.lineWidth) * 2;
                break;
            case LinePointShape.CIRCULAR_RADIATION:
                arrowH = new UiUtil().dip2px(lineContent.lineWidth) * 4;
                break;
            case LinePointShape.T_SHAPED:
                arrowH = new UiUtil().dip2px(lineContent.lineWidth);
                break;
            case LinePointShape.DIAMOND:
                arrowH = new UiUtil().dip2px(lineContent.lineWidth) * 2;
                break;
        }

        let endControlPoint = lineContent.getEndControlPoint();
        let toI = to.getRightAngleShapeHitPoint(endControlPoint, (arrowH + baseMargin));

        line.x = Math.min(targetI.x, toI.x);
        line.y = Math.min(targetI.y, toI.y);

        let startControlPointInLine = new CGPoint(startControlPoint.x - (line.x),
                   startControlPoint.y - (line.y));
        let endControlPointInLine = new CGPoint(endControlPoint.x - (line.x),
                endControlPoint.y - (line.y));
        let startPoint = new CGPoint(Math.abs((targetI.x) - line.x), Math.abs((targetI.y) - line.y));
        let endPoint = new CGPoint(Math.abs((toI.x) - line.x), Math.abs((toI.y) - line.y));

        lineContent.startPointX = Math.abs((targetI.x) - line.x);
        lineContent.startPointY = Math.abs((targetI.y) - line.y);
        lineContent.endPointX = Math.abs((toI.x) - line.x);
        lineContent.endPointY = Math.abs((toI.y) - line.y);
        if (target.type == MindElementType.NODE_CONNECT_LINE &&
            (lineContent.startShape == LinePointShape.ARROW ||
            lineContent.startShape == LinePointShape.BAMBOO_ARROW ||
            lineContent.startShape == LinePointShape.SIMPLE_ARROW ||
            lineContent.startShape == LinePointShape.T_SHAPED)) {
            arrowH = 0.0
            if (lineContent.startShape == LinePointShape.ARROW || lineContent.startShape == LinePointShape.BAMBOO_ARROW) {
                arrowH = new UiUtil().getArrowWidth(new Point( 0, 0), new Point( 0, 200), 
                        new UiUtil().dip2px(lineContent.lineWidth)) + new UiUtil().dip2px(4)
            }else if (lineContent.startShape == LinePointShape.SIMPLE_ARROW) {
                arrowH = new UiUtil().dip2px(4);
            } else {
                arrowH = (new UiUtil().dip2px(lineContent.lineWidth)/2 + 
                        new UiUtil().dip2px(target.lineContent.lineWidth)/2) + new UiUtil().dip2px(4);
            }
            var angle = 0;
            var distance = 0;
            var point
            switch (lineContent.connectLineType) {
                case ConnectLineType.STRAIGHT_ARROW_LINE:
                case ConnectLineType.STRAIGHT_CIRCULAR_LINE:
                    angle = Util.getCircleDegreesInPoint(endPoint, startPoint);
                    distance = Util.getPointSpacing(endPoint, startPoint);
                    distance = distance - arrowH;
                    point = Util.getCirclePoint(endPoint, angle, distance);
                    lineContent.startPointX = (point.x);
                    lineContent.startPointY = (point.y);
                    break;
                case ConnectLineType.CURVE_LINE:
                    angle = Util.getCircleDegreesInPoint(startControlPointInLine, startPoint);
                    distance = Util.getPointSpacing(startControlPointInLine, startPoint);
                    distance = distance - arrowH;
                    point = Util.getCirclePoint(startControlPointInLine, angle, distance);
                    lineContent.startPointX = (point.x);
                    lineContent.startPointY = (point.y);
                    break;
                case ConnectLineType.RIGHT_ANGLE_LINE:
                    if (lineContent.rightAnglePoints.length > 0) {
                        let point0 = new CGPoint(lineContent.rightAnglePoints[0].x, lineContent.rightAnglePoints[0].y);
                        let angle = Util.getCircleDegreesInPoint(point0, startPoint);
                        distance = Util.getPointSpacing(point0, startPoint);
                        distance = distance - arrowH;
                        point = Util.getCirclePoint(point0, angle, distance);
                        lineContent.startPointX = (point.x);
                        lineContent.startPointY = (point.y);
                    }
                break;
                default:
            }
        }
        if (to.type == MindElementType.NODE_CONNECT_LINE &&
            (lineContent.endShape == LinePointShape.ARROW ||
            lineContent.endShape == LinePointShape.BAMBOO_ARROW ||
            lineContent.endShape == LinePointShape.SIMPLE_ARROW ||
            lineContent.endShape == LinePointShape.T_SHAPED)) {
            arrowH = 0;
            if (lineContent.endShape == LinePointShape.ARROW || lineContent.endShape == LinePointShape.BAMBOO_ARROW) {
                arrowH = new UiUtil().getArrowWidth(new Point( 0, 0), new Point( 0, 200), 
                        new UiUtil().dip2px(lineContent.lineWidth)) + new UiUtil().dip2px(4)
            }else if (lineContent.endShape == LinePointShape.SIMPLE_ARROW) {
                arrowH = new UiUtil().dip2px(4);
            } else {
                arrowH = (new UiUtil().dip2px(lineContent.lineWidth)/2 + 
                        new UiUtil().dip2px(to.lineContent.lineWidth)/2) + new UiUtil().dip2px(4);
            }
            var angle = 0;
            var distance = 0;
            var point
            switch (lineContent.connectLineType) {
                case ConnectLineType.STRAIGHT_ARROW_LINE:
                case ConnectLineType.STRAIGHT_CIRCULAR_LINE:
                    angle = Util.getCircleDegreesInPoint(startPoint, endPoint);
                    distance = Util.getPointSpacing(endPoint, startPoint);
                    distance = distance - arrowH;
                    point = Util.getCirclePoint(startPoint, angle, distance);
                    lineContent.endPointX = (point.x);
                    lineContent.endPointY = (point.y);
                    break;
                case ConnectLineType.CURVE_LINE:
                    angle = Util.getCircleDegreesInPoint(endControlPointInLine, endPoint);
                    distance = Util.getPointSpacing(endControlPointInLine, endPoint);
                    distance = distance - arrowH;
                    point = Util.getCirclePoint(endControlPointInLine, angle, distance);
                    lineContent.endPointX = (point.x);
                    lineContent.endPointY = (point.y);
                    break;
                case ConnectLineType.RIGHT_ANGLE_LINE:
                    let count = lineContent.rightAnglePoints.length;
                    var point0;
                    if (count > 0) {
                        point0 = new CGPoint(lineContent.rightAnglePoints[count - 1].x, lineContent.rightAnglePoints[count - 1].y);
                    } else {
                        point0 = startPoint;
                    }
                    angle = Util.getCircleDegreesInPoint(point0, endPoint);
                    distance = Util.getPointSpacing(point0, endPoint);
                    distance = distance - arrowH;
                    point = Util.getCirclePoint(point0, angle, distance);
                    lineContent.endPointX = (point.x);
                    lineContent.endPointY = (point.y);
                    break;
                default:
            }
        }

        line.width = Math.abs(lineContent.startPointX - lineContent.endPointX);
        line.height = Math.abs(lineContent.startPointY - lineContent.endPointY);

        this.setRightAnglePoint(line, target, to);
        this.setConnectLineText(line, lineContent);
    }

    setConnectLineText(line, lineContent) {
        if (line == null || lineContent == null || line.isEmpty()) {
            return;
        }
        let textContent = line.lineContent.textContent;
        if (textContent == null) {
            textContent = new TextContent(new UiUtil().getString(strings.Mind_Usinghelp_Btn_3));
            if (Colors.isClear(this.mindBGColor)) {
                textContent.textColor = 0x333333;
            } else if (Colors.isDarkColor(this.mindBGColor)) {
                textContent.textColor = 0xffffff;
            } else {
                textContent.textColor = 0x333333;
            }
            textContent.textFontSize = 14;
            line.lineContent.textContent = textContent;
        }
        if (new Strings().isEmpty(textContent.text)) {
            textContent.text = new UiUtil().getString(strings.Mind_Usinghelp_Btn_3);
        }
        let size = MindElementCalculation.publicCaluleText(textContent.text, textContent.textFontSize, textContent.textBold);
        textContent.width = size.getWidth() + new UiUtil().dip2px(10);
        textContent.height = size.getHeight() + new UiUtil().dip2px(4);

        let startPoint = line.lineContent.startPoint();
        let endPoint = line.lineContent.endPoint();
        let x = line.width/2;
        let y = line.height/2;
        switch (lineContent.connectLineType) {
            case ConnectLineType.STRAIGHT_ARROW_LINE:
            case ConnectLineType.STRAIGHT_CIRCULAR_LINE:
                textContent.x = x - textContent.width/2;
                textContent.y = y - textContent.height/2;
                break;
            case ConnectLineType.CURVE_LINE:
                let startPointG = new CGPoint(startPoint.x + (line.x), startPoint.y + (line.y));
                let endPointG = new CGPoint(endPoint.x + (line.x), endPoint.y + (line.y));

                let precision = Math.floor(line.width - 1);
                var list = [];
                list.push(startPointG);
                list.push(line.lineContent.getStartControlPoint());
                list.push(line.lineContent.getEndControlPoint());
                list.push(endPointG);
                let points = new NodeConnectLineHit().bezierCalculate(list, precision);
                let pointsSize = points.length;
                if (points.isEmpty() || pointsSize < 2) {
                    textContent.x = x - textContent.width/2;
                    textContent.y = y - textContent.height/2;
                } else {
                    let centralPoint = points[Math.floor(pointsSize / 2)];
                    textContent.x = centralPoint.x - textContent.width/2 - line.x;
                    textContent.y = centralPoint.y - textContent.height/2 - line.y;
                }
                break;
            case ConnectLineType.RIGHT_ANGLE_LINE:
                let connectPoint = [];
                connectPoint.push(startPoint);
                let count = lineContent.rightAnglePoints.length;
                if (count > 0) {
                    for (let index = 0; index < count; index++) {
                        let cell = new Point((lineContent.rightAnglePoints[index].x),
                            (lineContent.rightAnglePoints[index].y))
                            connectPoint.push(cell);
                    }
                }
                connectPoint.push(endPoint);
                let connectPointSize = connectPoint.length;
                if (x > y) {
                    textContent.x = x - textContent.width/2;
                
                    if (connectPointSize > 1) {
                        for (let index = 0; index < connectPointSize; index++) {
                            if (index == connectPointSize-1) {
                                break;
                            }
                            let cell = connectPoint[index];
                            let nextCell = connectPoint[index + 1];
                            if (cell.x == x) {
                                textContent.y = cell.y - textContent.height/2;
                                break;
                            } else if (cell.x < x && nextCell.x > x) {
                                textContent.y = cell.y + (nextCell.y - cell.y) / 2 - textContent.height/2;
                                break;
                            } else if (cell.x > x && nextCell.x < x) {
                                textContent.y = cell.y + (nextCell.y - cell.y) / 2 - textContent.height/2;
                                break;
                            }
                        }
                    } else {
                        textContent.y = y - textContent.height/2;
                    }
                } else {
                    textContent.y = y - textContent.height/2;
                
                    if (connectPointSize > 1) {
                        for (let index = 0; index < connectPointSize; index++) {
                            if (index == connectPointSize-1) {
                                break;
                            }
                            let cell = connectPoint[index];
                            let nextCell = connectPoint[index + 1];
                            if (cell.y == y) {
                                textContent.x = cell.x - textContent.width/2;
                                break;
                            } else if (cell.y < y && nextCell.y > y) {
                                textContent.x = cell.x + (nextCell.x - cell.x) / 2 - textContent.width/2;
                                break;
                            } else if (cell.y > y && nextCell.y < y) {
                                textContent.x = cell.x + (nextCell.x - cell.x) / 2 - textContent.width/2;
                                break;
                            }
                        }
                    } else {
                        textContent.x = x - textContent.width/2;
                    }
                }
                
                break;
            default:
                textContent.x = x - textContent.width/2;
                textContent.y = y - textContent.height/2;
        }
    }

    checkControlPoint(line, target, to) {
        if (line.lineContent == null || target.isEmpty() || to.isEmpty()) {
            return;
        }
        let targetCenter = target.getCenterPoint();
        let toCenter = to.getCenterPoint();

        let toLeftCenter = new Point(to.x, toCenter.y);
        let toRightCenter = new Point(to.x + to.width, toCenter.y);

        let startControlPoint = line.lineContent.getStartControlPoint();
        let toAndTargetCenter = new Point(targetCenter.x + (toCenter.x - targetCenter.x)/2, targetCenter.y + (toCenter.y - targetCenter.y)/2);
        let targetLeftCenter = new Point(target.x, targetCenter.y);
        let targetRightCenter = new Point(target.x + target.width, targetCenter.y);
        let endControlPoint = line.lineContent.getEndControlPoint();
        let maxSpace = new UiUtil().dip2px(1250);

        if (Util.getPointSpacing(startControlPoint, targetCenter) > maxSpace) {
            if (Util.getPointSpacing(startControlPoint, targetLeftCenter) > maxSpace) {
                if (Util.getPointSpacing(startControlPoint, targetRightCenter) > maxSpace) {
                    if (Util.getPointSpacing(startControlPoint, toAndTargetCenter) > maxSpace) {
                        line.lineContent.startControlPointX = targetCenter.x
                        line.lineContent.startControlPointY = toAndTargetCenter.y
                    }
                }
            }
        }
        
        if (Util.getPointSpacing(endControlPoint, toCenter) > maxSpace) {
            if (Util.getPointSpacing(endControlPoint, toLeftCenter) > maxSpace) {
                if (Util.getPointSpacing(endControlPoint, toRightCenter) > maxSpace) {
                    if (Util.getPointSpacing(endControlPoint, toAndTargetCenter) > maxSpace) {
                        line.lineContent.endControlPointX = toCenter.x
                        line.lineContent.endControlPointY = toAndTargetCenter.y
                    }
                }
            }
        }        
    }

    //RIGHT_ANGLE_LINE
    setRightAnglePoint(line, target, to) {
        if (line.lineContent == null) {
            return;
        }

        let lineContent = line.lineContent;
        lineContent.rightAnglePoints = [];

        if (lineContent.connectLineType != ConnectLineType.RIGHT_ANGLE_LINE) {
            return;
        }

        let startPoint = lineContent.startPoint();
        let startPointGlobal = new Point(startPoint.x + (line.x), startPoint.y + (line.y));

        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(startPointGlobal, lineContent.getStartControlPoint());
            if (this.pointOnLeft(angle)) { //起点在目标点左侧
                this.startPointOnLeftTarget(line, target, to);
            } else if (this.pointOnRight(angle)) { //起点在目标点右侧
                this.startPointOnRightTarget(line, target, to);
            } else if (this.pointOnTop(angle)) { //起点在目标点上侧
                this.startPointOnTopTarget(line, target, to);
            } else {
                this.startPointOnBottomTarget(line, target, to);
            }
        } else {
            if (startPointGlobal.x < (target.x)) { //起点在目标点左侧
                this.startPointOnLeftTarget(line, target, to);
            } else if (startPointGlobal.x > (target.x + target.width)) { //起点在目标点右侧
                this.startPointOnRightTarget(line, target, to);
            } else if (this.checkDataTargetTop(line, target, to)) { //起点在目标点上侧
                this.startPointOnTopTarget(line, target, to);
            } else {
                this.startPointOnBottomTarget(line, target, to);
            }
        }
        let count = lineContent.rightAnglePoints.length;
        if (count > 0) {
            for (let index = 0; index < count; index++) {
                let item = lineContent.rightAnglePoints[index];
                lineContent.rightAnglePoints[index].x = item.x - line.x;
                lineContent.rightAnglePoints[index].y = item.y - line.y;
            }
        }
    }

    checkDataTargetTop(line, target, to) {
        if (line.lineContent == null) {
            return false;
        }

        let lineContent = line.lineContent;
        let startPoint = lineContent.startPoint();

        let startPointGlobal = new Point(startPoint.x + (line.x), startPoint.y + (line.y));
        let targetCenterPointGlobal = new Point((target.x + target.width / 2), (target.y + target.height / 2));

        if (target.mindElementShape == MindElementShapeType.Diamond ||
            target.mindElementShape == MindElementShapeType.Circular) {
            return startPointGlobal.y < targetCenterPointGlobal.y - new UiUtil().dip2px(4);
        } else {
            return startPointGlobal.y <= (target.y);
        }
    }

    checkDataToTop(line, target, to) {
        if (line.lineContent == null) {
            return false;
        }

        let lineContent = line.lineContent;
        let endPoint = lineContent.endPoint();

        let endPointGlobal = new Point(endPoint.x + (line.x), endPoint.y + (line.y));
        let toCenterPointGlobal = new Point((to.x + to.width / 2), (to.y + to.height / 2));

        if (to.mindElementShape == MindElementShapeType.Diamond ||
            to.mindElementShape == MindElementShapeType.Circular) {
            return endPointGlobal.y <= toCenterPointGlobal.y - new UiUtil().dip2px(4);
        } else {
            return endPointGlobal.y <= (to.y);
        }
    }

    checkDataTargetBottom(line, target, to) {
        if (line.lineContent == null) {
            return false;
        }

        let lineContent = line.lineContent;
        let startPoint = lineContent.startPoint();

        let startPointGlobal = new Point(startPoint.x + (line.x), startPoint.y + (line.y));
        let targetCenterPointGlobal = new Point((target.x + target.width / 2), (target.y + target.height / 2));

        if (target.mindElementShape == MindElementShapeType.Diamond ||
            target.mindElementShape == MindElementShapeType.Circular) {
            return startPointGlobal.y > targetCenterPointGlobal.y + new UiUtil().dip2px(4);
        } else {
            return startPointGlobal.y >= (target.y + target.height);
        }
    }

    checkDataToBottom(line, target, to) {
        if (line.lineContent == null) {
            return false;
        }

        let lineContent = line.lineContent;

        let endPoint = lineContent.endPoint();
        let endPointGlobal = new Point(endPoint.x + (line.x), endPoint.y + (line.y));
        let toCenterPointGlobal = new Point((to.x + to.width / 2), (to.y + to.height / 2));

        if (to.mindElementShape == MindElementShapeType.Diamond ||
            to.mindElementShape == MindElementShapeType.Circular) {
            return endPointGlobal.y >= toCenterPointGlobal.y + new UiUtil().dip2px(4);
        } else {
            return endPointGlobal.y >= (to.y + to.height);
        }
    }

    startPointOnBottomTarget(line, target, to) {
        if (line.lineContent == null) {
            return;
        }

        let lineContent = line.lineContent;
        lineContent.rightAnglePoints = [];

        if (lineContent.connectLineType != ConnectLineType.RIGHT_ANGLE_LINE) {
            return;
        }
        let minRightAngleSpace = new UiUtil().dip2px(15);

        let startPoint = lineContent.startPoint();
        let endPoint = lineContent.endPoint();
        let startPointGlobal = new Point(startPoint.x + (line.x), startPoint.y + (line.y));
        let endPointGlobal = new Point(endPoint.x + (line.x), endPoint.y + (line.y));

        let targetWidth = target.width;
        let targetHeight = target.height;
        let toWidth = to.width;
        let toHeight = to.height;

        let targetX = target.x;;
        let targetY = target.y;
        let toX = to.x;
        let toY = to.y;

        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            targetWidth = 10;
            targetHeight = 10;
            targetX = (startPointGlobal.x - 5);
            targetY = (startPointGlobal.y - 5);
        }
        if (to.type == MindElementType.NODE_CONNECT_LINE) {
            toWidth = 10;
            toHeight = 10;
            toX = (endPointGlobal.x - 5);
            toY = (endPointGlobal.y - 5);
        }

        let targetCenterPointGlobal = new Point((targetX + targetWidth / 2), (target.y + targetHeight / 2));
        let toCenterPointGlobal = new Point((toX + toWidth / 2), (toY + toHeight / 2));
        let startControlPoint = lineContent.getStartControlPoint();

        let startPointOnBottom = target.mindElementShape != MindElementShapeType.Diamond &&
                target.mindElementShape != MindElementShapeType.Circular &&
                target.mindElementShape != MindElementShapeType.Circular_Right_Top &&
                target.mindElementShape != MindElementShapeType.Ring &&
                target.mindElementShape != MindElementShapeType.Ring2 &&
                target.mindElementShape != MindElementShapeType.Ring2_UP &&
                target.mindElementShape != MindElementShapeType.Ring3 &&
                startPointGlobal.y > (targetY + targetHeight) ||
                (target.mindElementShape == MindElementShapeType.Diamond ||
                        target.mindElementShape == MindElementShapeType.Circular ||
                        target.mindElementShape == MindElementShapeType.Circular_Right_Top ||
                        target.mindElementShape == MindElementShapeType.Ring ||
                        target.mindElementShape == MindElementShapeType.Ring2 ||
                        target.mindElementShape == MindElementShapeType.Ring2_UP ||
                        target.mindElementShape == MindElementShapeType.Ring3) && startPointGlobal.y > (targetY + targetHeight / 2);
        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(startPointGlobal, lineContent.getStartControlPoint());
            startPointOnBottom = this.pointOnBottom(angle);
        }
        let endPointOnLeft = endPointGlobal.x <= (toX);
        let endPointOnRight = endPointGlobal.x >= (toX + toWidth);
        let endPointOnTop = this.checkDataToTop(line, target, to);
        if (to.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(endPointGlobal, lineContent.getEndControlPoint());
            endPointOnLeft = this.pointOnLeft(angle);
            endPointOnRight = this.pointOnRight(angle);
            endPointOnTop = this.pointOnTop(angle);
        }

        if (startPointOnBottom) { //起点在目标点下方
            if (endPointGlobal.y < startPointGlobal.y) { // 终点在起点的上方
                let dynamicWidth = startPointGlobal.y < startControlPoint.y ? (startControlPoint.y - startPointGlobal.y) / 2 : 0;
                let point1 = new Point(startPointGlobal.x, (startPointGlobal.y + minRightAngleSpace + dynamicWidth));
                lineContent.rightAnglePoints.push(new Point(point1.x, point1.y));
                if (endPointOnTop) { //终点在目标点的上方
                    if (startPointGlobal.x > endPointGlobal.x) { // 起点在终点右侧
                        if (targetX - (minRightAngleSpace) > toX + toWidth) {
                            lineContent.rightAnglePoints.push(new Point((targetX - minRightAngleSpace), (point1.y)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((toX - minRightAngleSpace), (point1.y)));
                        }
                    } else { // 起点在终点左侧
                        if (targetX + targetWidth + (minRightAngleSpace) < toX) {
                            lineContent.rightAnglePoints.push(new Point((targetX + targetWidth + (minRightAngleSpace)), (point1.y)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((toX + toWidth + (minRightAngleSpace)), (point1.y)));
                        }
                    }
                    lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x,
                        (endPointGlobal.y - minRightAngleSpace)));
                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                } else if (this.checkDataToBottom(line, target, to)) { //终点在目标点的下方
                    if (startPointGlobal.x > endPointGlobal.x) { // 起点在终点右侧
                        if (targetX - (minRightAngleSpace) < (endPointGlobal.x)) {
                            lineContent.rightAnglePoints.push(new Point(targetX - (minRightAngleSpace), (point1.y)));
                            lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y + minRightAngleSpace)));
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), (point1.y)));
                        }
                    } else {
                        if (targetX + targetWidth + (minRightAngleSpace) > (endPointGlobal.x)) {
                            lineContent.rightAnglePoints.push(new Point(targetX + targetWidth + (minRightAngleSpace), (point1.y)));
                            lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y + minRightAngleSpace)));
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), (point1.y)));
                        }
                    }
                } else if (endPointGlobal.x < (toX)) { //终点在目标点的左侧
                    if ((targetX + targetWidth) + minRightAngleSpace > (endPointGlobal.x) - minRightAngleSpace) {//终点在起点目标对象的左侧
                        if (targetX - (minRightAngleSpace) < (endPointGlobal.x - minRightAngleSpace)) {
                            lineContent.rightAnglePoints.push(new Point(targetX - (minRightAngleSpace), (point1.y)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x - minRightAngleSpace), (point1.y)));
                        }
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else {//终点在起点目标对象的右侧
                        lineContent.rightAnglePoints.push(new Point(targetX + targetWidth + (minRightAngleSpace), (point1.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    }
                } else { ////终点在目标点的右侧
                    if ((targetX) - minRightAngleSpace < (endPointGlobal.x) + minRightAngleSpace) {//终点在起点目标对象的右侧
                        if (targetX + targetWidth + (minRightAngleSpace) > (endPointGlobal.x + minRightAngleSpace)) {
                            lineContent.rightAnglePoints.push(new Point(targetX + targetWidth + (minRightAngleSpace), (point1.y)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x + minRightAngleSpace), (point1.y)));
                        }
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else {//终点在起点目标对象的左侧
                        lineContent.rightAnglePoints.push(new Point(targetX - (minRightAngleSpace), (point1.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    }
                }
            } else { // 终点在起点的下方
                let dynamicWidth = startPointGlobal.y < startControlPoint.y ? (startControlPoint.y - startPointGlobal.y) / 2 : 0;
                if (endPointOnRight) { //终点在目标点的右侧
                    if ((endPointGlobal.x + minRightAngleSpace) > startPointGlobal.x) {//终点在起点目标对象的右侧
                        let moveY = startPointGlobal.y + dynamicWidth + minRightAngleSpace > (toY) ?
                            (toY) - startPointGlobal.y : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y + moveY)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) + (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else { //终点在起点目标对象的左侧
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (endPointGlobal.y)));
                    }
                } else if (endPointGlobal.y > (toY + toHeight)) { //终点在目标点的下方
                    if ((toX) < startPointGlobal.x && (toX + toWidth) > startPointGlobal.x) {
                        let moveY = startPointGlobal.y + dynamicWidth + minRightAngleSpace > (toY) ?
                            (toY) - startPointGlobal.y : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y + moveY)));

                        if (endPointGlobal.x > startPointGlobal.x) {
                            lineContent.rightAnglePoints.push(new Point(toX - (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        } else {
                            lineContent.rightAnglePoints.push(new Point(toX + toWidth + (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        }
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y + minRightAngleSpace)));

                    } else {
                        let moveY = startPointGlobal.y + dynamicWidth + minRightAngleSpace < (endPointGlobal.y + minRightAngleSpace) ?
                            (endPointGlobal.y + minRightAngleSpace) - startPointGlobal.y : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y + moveY)));
                    }

                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));

                } else if (endPointOnLeft) { //终点在目标点的左侧
                    if ((endPointGlobal.x - minRightAngleSpace) < startPointGlobal.x) {//终点在起点目标对象的右侧
                        let moveY = startPointGlobal.y + dynamicWidth + minRightAngleSpace > (toY) ?
                            (toY) - startPointGlobal.y : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y + moveY)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) - (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else { //终点在起点目标对象的左侧
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (endPointGlobal.y)));
                    }
                } else { ////终点在目标点的上方
                    let moveY = startPointGlobal.y + dynamicWidth + minRightAngleSpace > endPointGlobal.y ?
                        endPointGlobal.y - startPointGlobal.y : dynamicWidth + minRightAngleSpace;
                    lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y + moveY)));
                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                }
            }
        }
    }

    startPointOnTopTarget(line, target, to) {
        if (line.lineContent == null) {
            return;
        }

        let lineContent = line.lineContent;
        lineContent.rightAnglePoints = [];

        if (lineContent.connectLineType != ConnectLineType.RIGHT_ANGLE_LINE) {
            return;
        }
        let minRightAngleSpace = new UiUtil().dip2px(15);

        let startPoint = lineContent.startPoint();
        let endPoint = lineContent.endPoint();
        let startPointGlobal = new Point(startPoint.x + (line.x), startPoint.y + (line.y));
        let endPointGlobal = new Point(endPoint.x + (line.x), endPoint.y + (line.y));

        let targetWidth = target.width;
        let targetHeight = target.height;
        let toWidth = to.width;
        let toHeight = to.height;

        let targetX = target.x;;
        let targetY = target.y;
        let toX = to.x;
        let toY = to.y;

        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            targetWidth = 10;
            targetHeight = 10;
            targetX = (startPointGlobal.x - 5);
            targetY = (startPointGlobal.y - 5);
        }
        if (to.type == MindElementType.NODE_CONNECT_LINE) {
            toWidth = 10;
            toHeight = 10;
            toX = (endPointGlobal.x - 5);
            toY = (endPointGlobal.y - 5);
        }

        let targetCenterPointGlobal = new Point((targetX + targetWidth / 2), (targetY + targetHeight / 2));
        let toCenterPointGlobal = new Point((toX + toWidth / 2), (toY + toHeight / 2));
        let startControlPoint = lineContent.getStartControlPoint();

        let startPointOnTop = this.checkDataTargetTop(line, target, to);
        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(startPointGlobal, lineContent.getStartControlPoint());
            startPointOnTop = this.pointOnTop(angle);
        }
        let endPointOnLeft = endPointGlobal.x <= (toX);
        let endPointOnRight = endPointGlobal.x >= (toX + toWidth);
        let endPointOnTop = this.checkDataToTop(line, target, to);
        if (to.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(endPointGlobal, lineContent.getEndControlPoint());
            endPointOnLeft = this.pointOnLeft(angle);
            endPointOnRight = this.pointOnRight(angle);
            endPointOnTop = this.pointOnTop(angle);
        }

        if (startPointOnTop) { //起点在目标点上方
            if (endPointGlobal.y > startPointGlobal.y) { // 终点在起点的下方
                let dynamicWidth = startPointGlobal.y > startControlPoint.y ? (startPointGlobal.y - startControlPoint.y) / 2 : 0;
                let point1 = new Point(startPointGlobal.x, startPointGlobal.y - minRightAngleSpace - dynamicWidth);
                lineContent.rightAnglePoints.push(new Point((point1.x), (point1.y)));
                if (this.checkDataToBottom(line, target, to)) { //终点在目标点的下方
                    if (startPointGlobal.x > endPointGlobal.x) { // 起点在终点右侧
                        if (targetX - (minRightAngleSpace) > toX + toWidth) {
                            lineContent.rightAnglePoints.push(new Point(targetX - (minRightAngleSpace), (point1.y)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point(toX - (minRightAngleSpace), (point1.y)));
                        }
                    } else { // 起点在终点左侧
                        if (targetX + targetWidth + (minRightAngleSpace) < toX) {
                            lineContent.rightAnglePoints.push(new Point(targetX + targetWidth + (minRightAngleSpace), (point1.y)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point(toX + toWidth + (minRightAngleSpace), (point1.y)));
                        }
                    }
                    lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x,
                        (endPointGlobal.y + minRightAngleSpace)));
                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                } else if (endPointOnTop) { //终点在目标点的上方
                    if (startPointGlobal.x > endPointGlobal.x) { // 起点在终点右侧
                        if (targetX - (minRightAngleSpace) < (endPointGlobal.x)) {
                            lineContent.rightAnglePoints.push(new Point(targetX - (minRightAngleSpace), (point1.y)));
                            lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y - minRightAngleSpace)));
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), (point1.y)));
                        }
                    } else {
                        if (targetX + targetWidth + (minRightAngleSpace) > (endPointGlobal.x)) {
                            lineContent.rightAnglePoints.push(new Point(targetX + targetWidth + (minRightAngleSpace), (point1.y)));
                            lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y - minRightAngleSpace)));
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), (point1.y)));
                        }
                    }
                } else if (endPointGlobal.x < (toX)) { //终点在目标点的左侧
                    if ((targetX + targetWidth) + minRightAngleSpace > (endPointGlobal.x) - minRightAngleSpace) {//终点在起点目标对象的左侧
                        if (targetX - (minRightAngleSpace) < (endPointGlobal.x - minRightAngleSpace)) {
                            lineContent.rightAnglePoints.push(new Point(targetX - (minRightAngleSpace), (point1.y)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x - minRightAngleSpace), (point1.y)));
                        }
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else {//终点在起点目标对象的右侧
                        lineContent.rightAnglePoints.push(new Point(targetX + targetWidth + (minRightAngleSpace), (point1.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    }
                } else { ////终点在目标点的右侧
                    if ((targetX) - minRightAngleSpace < (endPointGlobal.x) + minRightAngleSpace) {//终点在起点目标对象的右侧
                        if (targetX + targetWidth + (minRightAngleSpace) > (endPointGlobal.x + minRightAngleSpace)) {
                            lineContent.rightAnglePoints.push(new Point(targetX + targetWidth + (minRightAngleSpace), (point1.y)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x + minRightAngleSpace), (point1.y)));
                        }
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else {//终点在起点目标对象的左侧
                        lineContent.rightAnglePoints.push(new Point(targetX - (minRightAngleSpace), (point1.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    }
                }
            } else { // 终点在起点的上放---
                let dynamicWidth = startPointGlobal.y > startControlPoint.y ? (startPointGlobal.y - startControlPoint.y) / 2 : 0;
                if (endPointOnRight) { //终点在目标点的右侧
                    if ((endPointGlobal.x + minRightAngleSpace) > startPointGlobal.x) {//终点在起点目标对象的右侧
                        if (startPointGlobal.y - dynamicWidth - minRightAngleSpace > (toY) &&
                            startPointGlobal.y - dynamicWidth - minRightAngleSpace < (toY + toHeight)) {
                            if (startPointGlobal.x > (toX) &&
                                startPointGlobal.x < (toX + toWidth)) {
                                let moveY = startPointGlobal.y - dynamicWidth - minRightAngleSpace < (toY + toHeight) ?
                                    startPointGlobal.y - (toY + toHeight) : dynamicWidth + minRightAngleSpace;
                                lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y - moveY)));
                                lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) + (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                                lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                            } else {
                                let moveY = startPointGlobal.y - (toY) + minRightAngleSpace;
                                lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y - moveY)));
                                lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) + (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                                lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                            }
                        } else {
                            if (startPointGlobal.x > (toX) &&
                                startPointGlobal.x < (toX + toWidth)) {
                                let moveY = startPointGlobal.y - dynamicWidth - minRightAngleSpace < (toY + toHeight) ?
                                    startPointGlobal.y - (toY + toHeight) : dynamicWidth + minRightAngleSpace;
                                lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y - moveY)));
                                lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) + (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                                lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                            } else {
                                let moveY = startPointGlobal.y - dynamicWidth - minRightAngleSpace < (toY + toHeight) &&
                                    startPointGlobal.y - dynamicWidth - minRightAngleSpace > (toY) ?
                                    startPointGlobal.y - (toY) - minRightAngleSpace : dynamicWidth + minRightAngleSpace;
                                lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y - moveY)));
                                lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) + (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                                lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                            }
                        }
                    } else { //终点在起点目标对象的左侧
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (endPointGlobal.y)));
                    }
                } else if (endPointOnTop) { //终点在目标点的上方
                    if ((toX) < startPointGlobal.x && (toX + toWidth) > startPointGlobal.x) {
                        let moveY = startPointGlobal.y - dynamicWidth - minRightAngleSpace < (toY + toHeight) ?
                            startPointGlobal.y - (toY + toHeight) : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y - moveY)));

                        if (endPointGlobal.x > startPointGlobal.x) {
                            lineContent.rightAnglePoints.push(new Point(toX - (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        } else {
                            lineContent.rightAnglePoints.push(new Point(toX + toWidth + (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        }
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y - minRightAngleSpace)));

                    } else {
                        let moveY = startPointGlobal.y - dynamicWidth - minRightAngleSpace > (endPointGlobal.y - minRightAngleSpace) ?
                            startPointGlobal.y - (endPointGlobal.y - minRightAngleSpace) : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y - moveY)));
                    }

                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));

                } else if (endPointOnLeft) { //终点在目标点的左侧
                    if ((endPointGlobal.x - minRightAngleSpace) < startPointGlobal.x) {//终点在起点目标对象的右侧
                        let moveY = startPointGlobal.y - dynamicWidth - minRightAngleSpace < (toY + toHeight) ?
                            startPointGlobal.y - (toY + toHeight) : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y - moveY)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) - (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else { //终点在起点目标对象的左侧
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (endPointGlobal.y)));
                    }
                } else { ////终点在目标点的下方
                    let moveY = startPointGlobal.y - dynamicWidth - minRightAngleSpace < endPointGlobal.y ?
                        startPointGlobal.y - endPointGlobal.y : dynamicWidth + minRightAngleSpace;
                    lineContent.rightAnglePoints.push(new Point((startPointGlobal.x), (startPointGlobal.y - moveY)));
                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                }
            }
        }
    }

    startPointOnRightTarget(line, target, to) {
        if (line.lineContent == null) {
            return;
        }

        let lineContent = line.lineContent;
        lineContent.rightAnglePoints = [];

        if (lineContent.connectLineType != ConnectLineType.RIGHT_ANGLE_LINE) {
            return;
        }
        let minRightAngleSpace = new UiUtil().dip2px(15);

        let startPoint = lineContent.startPoint();
        let endPoint = lineContent.endPoint();
        let startPointGlobal = new Point(startPoint.x + (line.x), startPoint.y + (line.y));
        let endPointGlobal = new Point(endPoint.x + (line.x), endPoint.y + (line.y));

        let targetWidth = target.width;
        let targetHeight = target.height;
        let toWidth = to.width;
        let toHeight = to.height;

        let targetX = target.x;;
        let targetY = target.y;
        let toX = to.x;
        let toY = to.y;

        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            targetWidth = 10;
            targetHeight = 10;
            targetX = (startPointGlobal.x - 5);
            targetY = (startPointGlobal.y - 5);
        }
        if (to.type == MindElementType.NODE_CONNECT_LINE) {
            toWidth = 10;
            toHeight = 10;
            toX = (endPointGlobal.x - 5);
            toY = (endPointGlobal.y - 5);
        }

        let targetCenterPointGlobal = new Point((targetX + targetWidth / 2), (targetY + targetHeight / 2));
        let toCenterPointGlobal = new Point((toX + toWidth / 2), (toY + toHeight / 2));
        let startControlPoint = lineContent.getStartControlPoint();

        let startPointOnRight = startPointGlobal.x > (targetX + targetWidth);
        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(startPointGlobal, lineContent.getStartControlPoint());
            startPointOnRight = this.pointOnRight(angle);
        }
        let endPointOnLeft = endPointGlobal.x <= (toX);
        let endPointOnRight = endPointGlobal.x >= (toX + toWidth);
        let endPointOnTop = this.checkDataToTop(line, target, to);
        if (to.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(endPointGlobal, lineContent.getEndControlPoint());
            endPointOnLeft = this.pointOnLeft(angle);
            endPointOnRight = this.pointOnRight(angle);
            endPointOnTop = this.pointOnTop(angle);
        }

        if (startPointOnRight) { //起点在目标点左侧
            if (endPointGlobal.x < startPointGlobal.x) { // 终点在起点的左侧
                let dynamicWidth = startPointGlobal.x < startControlPoint.x ? (startControlPoint.x - startPointGlobal.x) / 2 : 0;
                let point1 = new Point(startPointGlobal.x + minRightAngleSpace + dynamicWidth, startPointGlobal.y);
                lineContent.rightAnglePoints.push(new Point((point1.x), (point1.y)));//------
                if (endPointOnRight) { //终点在目标点的右侧
                    if ((targetY) < endPointGlobal.y && (targetY + targetHeight) > endPointGlobal.y) {//终点在起点目标对象的正前方
                        if (startPointGlobal.y > endPointGlobal.y) { // 起点在终点下方
                            lineContent.rightAnglePoints.push(new Point((point1.x), targetY + targetHeight + (minRightAngleSpace)));
                        } else { // 起点在终点上方
                            lineContent.rightAnglePoints.push(new Point((point1.x), targetY - (minRightAngleSpace)));
                        }
                        if (endPointGlobal.x + minRightAngleSpace > (targetX)) {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x + ((targetX) - endPointGlobal.x) / 2), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x + minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        }
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));

                    } else { //终点在起点目标对象的后方上、下
                        lineContent.rightAnglePoints.push(new Point((point1.x), (endPointGlobal.y)));
                    }
                } else if (endPointOnTop) { //终点在目标点的上方
                    if (endPointGlobal.y - minRightAngleSpace > (targetY) &&
                        endPointGlobal.y - minRightAngleSpace < (targetY + targetHeight)) {
                        lineContent.rightAnglePoints.push(new Point((point1.x), targetY - (minRightAngleSpace)));
                    } else {
                        lineContent.rightAnglePoints.push(new Point((point1.x), (endPointGlobal.y - minRightAngleSpace)));
                    }
                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));

                } else if (endPointGlobal.x < (toX)) { //终点在目标点的左侧
                    if ((targetY) < (toY) - minRightAngleSpace &&
                        (targetY + targetHeight) > (toY) - minRightAngleSpace &&
                        (targetY) < (toY + toHeight) + minRightAngleSpace &&
                        (targetY + targetHeight) > (toY + toHeight) + minRightAngleSpace) {//终点在起点目标对象的正前方
                        if (startPointGlobal.y > endPointGlobal.y) { // 起点在终点下方
                            lineContent.rightAnglePoints.push(new Point((point1.x), targetY + targetHeight + (minRightAngleSpace)));
                        } else { // 起点在终点上方
                            lineContent.rightAnglePoints.push(new Point((point1.x), targetY - (minRightAngleSpace)));
                        }
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x - minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else if ((targetY) < (toY) - minRightAngleSpace &&
                        (targetY + targetHeight) > (toY) - minRightAngleSpace) {//终点在起点目标对象的正前方
                        lineContent.rightAnglePoints.push(new Point((point1.x), targetY + targetHeight + (minRightAngleSpace)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x - minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else if ((targetY) < (toY + toHeight) + minRightAngleSpace &&
                        (targetY + targetHeight) > (toY + toHeight) + minRightAngleSpace) {//终点在起点目标对象的正前方
                        lineContent.rightAnglePoints.push(new Point((point1.x), targetY - (minRightAngleSpace)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x - minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else { //终点在起点目标对象的后方上、下 // if (targetY) >= (toY + toHeight) + minRightAngleSpace
                        if (endPointGlobal.y >= toCenterPointGlobal.y) { //从下方拉线
                            lineContent.rightAnglePoints.push(new Point((point1.x), (toY + toHeight) + (minRightAngleSpace)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((point1.x), toY - (minRightAngleSpace)));
                        }
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x - minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    }
                } else { ////终点在目标点的下方
                    if (endPointGlobal.y + minRightAngleSpace > (targetY) &&
                        endPointGlobal.y + minRightAngleSpace < (targetY + targetHeight)) {
                        lineContent.rightAnglePoints.push(new Point((point1.x), targetY + targetHeight + (minRightAngleSpace)));
                    } else {
                        lineContent.rightAnglePoints.push(new Point((point1.x), (endPointGlobal.y + minRightAngleSpace)));
                    }
                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                }
            } else { // 终点在起点的右侧
                let dynamicWidth = startPointGlobal.x < startControlPoint.x ? (startControlPoint.x - startPointGlobal.x) / 2 : 0;
                if (endPointOnRight) { //终点在目标点的右侧
                    if ((startPointGlobal.y) < (toY + toHeight) &&
                        (startPointGlobal.y) > (toY)) {//终点在起点目标对象的正后方
                        let moveX = startPointGlobal.x + dynamicWidth + minRightAngleSpace > (toX) ?
                            (toX) - startPointGlobal.x : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x + moveX), (startPointGlobal.y)));

                        if (startPointGlobal.y > endPointGlobal.y) { // 起点在终点下方
                            lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (toY + toHeight) + (minRightAngleSpace)));
                        } else { // 起点在终点上方
                            lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (toY) - (minRightAngleSpace)));
                        }

                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) + (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else { //终点在起点目标对象的后方上、下
                        let moveX = startPointGlobal.x + dynamicWidth + minRightAngleSpace > endPointGlobal.x + minRightAngleSpace ?
                            dynamicWidth + minRightAngleSpace : endPointGlobal.x + minRightAngleSpace - startPointGlobal.x;

                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x + moveX), (startPointGlobal.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    }
                } else if (endPointOnTop) { //终点在目标点的上方
                    if (endPointGlobal.y > startPointGlobal.y) {
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), (startPointGlobal.y)));
                    } else {
                        let moveX = startPointGlobal.x + dynamicWidth + minRightAngleSpace > (toX) ?
                            (toX) - startPointGlobal.x : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x + moveX), (startPointGlobal.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y - minRightAngleSpace)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                    }
                } else if (endPointOnLeft) { //终点在目标点的左侧
                    let moveX = startPointGlobal.x + dynamicWidth + minRightAngleSpace > (toX) ?
                        (toX) - startPointGlobal.x : dynamicWidth + minRightAngleSpace;
                    lineContent.rightAnglePoints.push(new Point((startPointGlobal.x + moveX), (startPointGlobal.y)));
                    lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                } else { ////终点在目标点的下方
                    if (endPointGlobal.y < startPointGlobal.y) {
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), (startPointGlobal.y)));
                    } else {
                        let moveX = startPointGlobal.x + dynamicWidth + minRightAngleSpace > (toX) ?
                            (toX) - startPointGlobal.x : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x + moveX), (startPointGlobal.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y + minRightAngleSpace)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                    }
                }
            }
        }
    }

    startPointOnLeftTarget(line, target, to) {
        if (line.lineContent == null) {
            return;
        }

        let lineContent = line.lineContent;
        lineContent.rightAnglePoints = [];

        if (lineContent.connectLineType != ConnectLineType.RIGHT_ANGLE_LINE) {
            return;
        }
        let minRightAngleSpace = new UiUtil().dip2px(15);

        let startPoint = lineContent.startPoint();
        let endPoint = lineContent.endPoint();
        let startPointGlobal = new Point(startPoint.x + (line.x), startPoint.y + (line.y));
        let endPointGlobal = new Point(endPoint.x + (line.x), endPoint.y + (line.y));

        let targetWidth = target.width;
        let targetHeight = target.height;
        let toWidth = to.width;
        let toHeight = to.height;

        let targetX = target.x;;
        let targetY = target.y;
        let toX = to.x;
        let toY = to.y;

        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            targetWidth = 10;
            targetHeight = 10;
            targetX = (startPointGlobal.x - 5);
            targetY = (startPointGlobal.y - 5);
        }
        if (to.type == MindElementType.NODE_CONNECT_LINE) {
            toWidth = 10;
            toHeight = 10;
            toX = (endPointGlobal.x - 5);
            toY = (endPointGlobal.y - 5);
        }

        let targetCenterPointGlobal = new Point((targetX + targetWidth / 2), (targetY + targetHeight / 2));
        let toCenterPointGlobal = new Point((toX + toWidth / 2), (toY + toHeight / 2));
        let startControlPoint = lineContent.getStartControlPoint();

        let startPointOnLeft = startPointGlobal.x < (targetX);
        if (target.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(startPointGlobal, lineContent.getStartControlPoint());
            startPointOnLeft = this.pointOnLeft(angle);
        }
        let endPointOnLeft = endPointGlobal.x <= (toX);
        let endPointOnRight = endPointGlobal.x >= (toX + toWidth);
        let endPointOnTop = this.checkDataToTop(line, target, to);
        if (to.type == MindElementType.NODE_CONNECT_LINE) {
            let angle = Util.getCircleDegreesInPoint(endPointGlobal, lineContent.getEndControlPoint());
            endPointOnLeft = this.pointOnLeft(angle);
            endPointOnRight = this.pointOnRight(angle);
            endPointOnTop = this.pointOnTop(angle);
        }

        if (startPointOnLeft) { //起点在目标点左侧
            if (endPointGlobal.x >= startPointGlobal.x) { // 终点在起点的右侧
                let dynamicWidth = startPointGlobal.x > startControlPoint.x ? (startPointGlobal.x - startControlPoint.x) / 2 : 0;
                let point1 = new Point(startPointGlobal.x - minRightAngleSpace - dynamicWidth, startPointGlobal.y);
                lineContent.rightAnglePoints.push(new Point((point1.x), (point1.y)));
                if (endPointOnLeft) { //终点在目标点的左侧
                    if ((targetY) < endPointGlobal.y &&
                        (targetY + targetHeight) > endPointGlobal.y) {//终点在起点目标对象的正后方
                        if (startPointGlobal.y > endPointGlobal.y) { // 起点在终点下方
                            lineContent.rightAnglePoints.push(new Point((point1.x), targetY + targetHeight + (minRightAngleSpace)));
                        } else { // 起点在终点上方
                            lineContent.rightAnglePoints.push(new Point((point1.x), targetY - (minRightAngleSpace)));
                        }
                        if (endPointGlobal.x - minRightAngleSpace < (targetX + targetWidth)) {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x - (endPointGlobal.x - (targetX + targetWidth)) / 2), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((endPointGlobal.x - minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        }
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));

                    } else { //终点在起点目标对象的后方上、下
                        lineContent.rightAnglePoints.push(new Point((point1.x), (endPointGlobal.y)));
                    }
                } else if (endPointOnTop) { //终点在目标点的上方
                    if (endPointGlobal.y - minRightAngleSpace > (targetY) &&
                        endPointGlobal.y - minRightAngleSpace < (targetY + targetHeight)) {
                        lineContent.rightAnglePoints.push(new Point((point1.x), targetY - (minRightAngleSpace)));
                    } else {
                        lineContent.rightAnglePoints.push(new Point((point1.x), (endPointGlobal.y - minRightAngleSpace)));
                    }
                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));

                } else if (endPointOnRight) { //终点在目标点的右侧
                    if ((targetY) < (toY) - minRightAngleSpace &&
                        (targetY + targetHeight) > (toY + toHeight) + minRightAngleSpace) {//终点在起点目标对象的正后方
                        if (startPointGlobal.y > endPointGlobal.y) { // 起点在终点下方
                            lineContent.rightAnglePoints.push(new Point((point1.x), targetY + targetHeight + (minRightAngleSpace)));
                        } else { // 起点在终点上方
                            lineContent.rightAnglePoints.push(new Point((point1.x), targetY - (minRightAngleSpace)));
                        }
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x + minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else { //终点在起点目标对象的后方上、下 // if (targetY) >= (toY + toHeight) + minRightAngleSpace
                        if (endPointGlobal.y >= toCenterPointGlobal.y) { //从下方拉线
                            lineContent.rightAnglePoints.push(new Point((point1.x), (toY + toHeight) + (minRightAngleSpace)));
                        } else {
                            lineContent.rightAnglePoints.push(new Point((point1.x), toY - (minRightAngleSpace)));
                        }
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x + minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    }
                } else { ////终点在目标点的下方
                    if (endPointGlobal.y + minRightAngleSpace > (targetY) &&
                        endPointGlobal.y + minRightAngleSpace < (targetY + targetHeight)) {
                        lineContent.rightAnglePoints.push(new Point((point1.x), targetY + targetHeight + (minRightAngleSpace)));
                    } else {
                        lineContent.rightAnglePoints.push(new Point((point1.x), (endPointGlobal.y + minRightAngleSpace)));
                    }
                    lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                }
            } else { // 终点在起点的左侧
                let dynamicWidth = startPointGlobal.x > startControlPoint.x ? (startPointGlobal.x - startControlPoint.x) / 2 : 0;
                if (endPointOnLeft) { //终点在目标点的左侧
                    if ((startPointGlobal.y) < (toY + toHeight) &&
                        (startPointGlobal.y) > (toY)) {//终点在起点目标对象的正前方
                        let moveX = (toX + toWidth) + dynamicWidth + minRightAngleSpace > startPointGlobal.x ?
                            startPointGlobal.x - (toX + toWidth) : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x - moveX), (startPointGlobal.y)));

                        if (startPointGlobal.y > endPointGlobal.y) { // 起点在终点下方
                            lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (toY + toHeight) + (minRightAngleSpace)));
                        } else { // 起点在终点上方
                            lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (toY) - (minRightAngleSpace)));
                        }

                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x) - (minRightAngleSpace), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    } else { //终点在起点目标对象的后方上、下
                        let moveX = startPointGlobal.x - dynamicWidth - minRightAngleSpace < endPointGlobal.x - minRightAngleSpace ?
                            dynamicWidth + minRightAngleSpace : startPointGlobal.x - (endPointGlobal.x - minRightAngleSpace);
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x - moveX), (startPointGlobal.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                    }
                } else if (endPointOnTop) { //终点在目标点的上方
                    if (endPointGlobal.y > startPointGlobal.y) {
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), (startPointGlobal.y)));
                    } else {
                        let moveX = (toX + toWidth) + dynamicWidth + minRightAngleSpace > startPointGlobal.x ?
                            startPointGlobal.x - (toX + toWidth) : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x - moveX), (startPointGlobal.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y - minRightAngleSpace)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                    }
                } else if (endPointOnRight) { //终点在目标点的右侧
                    let moveX = (toX + toWidth) + dynamicWidth + minRightAngleSpace > startPointGlobal.x ?
                        startPointGlobal.x - (toX + toWidth) : dynamicWidth + minRightAngleSpace;
                    lineContent.rightAnglePoints.push(new Point((startPointGlobal.x - moveX), (startPointGlobal.y)));
                    lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y)));
                } else { ////终点在目标点的下方
                    if (endPointGlobal.y < startPointGlobal.y) {
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), (startPointGlobal.y)));
                    } else {
                        let moveX = (toX + toWidth) + dynamicWidth + minRightAngleSpace > startPointGlobal.x ?
                            startPointGlobal.x - (toX + toWidth) : dynamicWidth + minRightAngleSpace;
                        lineContent.rightAnglePoints.push(new Point((startPointGlobal.x - moveX), (startPointGlobal.y)));
                        lineContent.rightAnglePoints.push(new Point(lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].x, (endPointGlobal.y + minRightAngleSpace)));
                        lineContent.rightAnglePoints.push(new Point((endPointGlobal.x), lineContent.rightAnglePoints[lineContent.rightAnglePoints.length - 1].y));
                    }
                }
            }
        }
    }

    initConnectLineControlPoint(line, target, to, isCheckControlPoint = true) {
        if (target.isEmpty() || to.isEmpty()) {
            return;
        }
        let lineContent = line.lineContent;
        if (lineContent == null) {
            return;
        }
        switch (lineContent.connectLineType) {
            case ConnectLineType.STRAIGHT_ARROW_LINE:
            case ConnectLineType.STRAIGHT_CIRCULAR_LINE:
                this.straightArrowControlPoint(line, target, to);
                break;
            case ConnectLineType.CURVE_LINE:
                this.curveControlPoint(line, target, to);
                break;
            case ConnectLineType.RIGHT_ANGLE_LINE:
                this.rightAngleControlPoint(line, target, to);
                break;
            default:
                this.straightArrowControlPoint(line, target, to);
        }
        if (isCheckControlPoint) {
            this.checkControlPoint(line, target, to)
        }
    }

    straightArrowControlPoint(line, target, to) {
        if (target.isEmpty() || to.isEmpty()) {
            return;
        }
        let lineContent = line.lineContent;
        if (lineContent == null) {
            return;
        }
        let targetCenter = target.getCenterPoint();
        let toCenter = to.getCenterPoint();

        if (lineContent.startControlPointX <= 0 || lineContent.startControlPointY <= 0 ||
            lineContent.startControlPointX > targetCenter.x + 5000 ||
            lineContent.startControlPointY > targetCenter.y + 5000 ||
            lineContent.endControlPointX <= 0 || lineContent.endControlPointY <= 0 ||
            lineContent.endControlPointX > to.x + 5000 ||
            lineContent.endControlPointY > to.y + 5000) {
            let Xspaceing = (targetCenter.x - toCenter.x);
            let Yspaceing = (targetCenter.y - toCenter.y);
            let minSpaceX = new UiUtil().dip2px(90);
            let minSpaceY = new UiUtil().dip2px(90);

            let startControlPointX = 0;
            let startControlPointY = 0;
            let endControlPointX = 0;
            let endControlPointY = 0;

            if (Math.abs(Yspaceing) > Math.abs(Xspaceing)) { // 高大于宽
                if (Yspaceing < 0) { // 下方
                    startControlPointY = (targetCenter.y) - target.y + minSpaceY;
                    endControlPointY = -((toCenter.y) - to.y + minSpaceY);
                } else {
                    startControlPointY = -((targetCenter.y) - target.y + minSpaceY);
                    endControlPointY = (toCenter.y) - to.y + minSpaceY;
                }
                startControlPointX = 0;
                endControlPointX = 0;
            } else {
                if (Xspaceing < 0) { // 右侧
                    startControlPointX = (targetCenter.x) - target.x + minSpaceX;
                    endControlPointX = -((toCenter.x) - to.x + minSpaceX);
                } else {
                    startControlPointX = -((targetCenter.x) - target.x + minSpaceX);
                    endControlPointX = (toCenter.x) - to.x + minSpaceX;
                }
                startControlPointY = 0;
                endControlPointY = 0;
            }

            lineContent.startControlPointX = startControlPointX + (targetCenter.x);
            lineContent.startControlPointY = startControlPointY + (targetCenter.y);

            lineContent.endControlPointX = endControlPointX + (toCenter.x);
            lineContent.endControlPointY = endControlPointY + (toCenter.y);

            if (to.type == MindElementType.NODE_CONNECT_LINE && to.lineContent != null &&
                to.lineContent.startControlPointX > 0 && to.lineContent.startControlPointY > 0 &&
                to.lineContent.endControlPointX > 0 && to.lineContent.endControlPointY > 0) {
                if (this.lastClickPoint.isJustSetPoint() && this.lastClickPoint.getId() == to.id &&
                    this.lastClickPoint.getPoint().x > 0 && this.lastClickPoint.getPoint().y > 0) {

                    let start = to.lineContent.startPoint();
                    let end = to.lineContent.endPoint();
                    let space = new UiUtil().dip2px(40);
                    let angle = Util.getCircleDegreesInPoint(start, end);
                    if (this.pointOnLeft(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y - space);
                    } else if (this.pointOnRight(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y + space);
                    } else if (this.pointOnTop(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x - space);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y);
                    } else {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x + space);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y);
                    }
                }
            }
        }
    }

    curveControlPoint(line, target, to) {
        if (target.isEmpty() || to.isEmpty()) {
            return;
        }
        let lineContent = line.lineContent;
        if (lineContent == null) {
            return;
        }
        let startPoint;
        let endPoint;

        let targetTopCenterX = target.x + target.width / 2;
        let targetTopCenterY = target.y;
        let targetBottomCenterX = targetTopCenterX;
        let targetBottomCenterY = targetTopCenterY + target.height;

        let targetLeftCenterX = target.x;
        let targetLeftCenterY = target.y + target.height / 2;
        let targetRightCenterX = target.x + target.width;
        let targetRightCenterY = targetLeftCenterY;

        let toTopCenterX = to.x + to.width / 2;
        let toTopCenterY = to.y;
        let toBottomCenterX = toTopCenterX;
        let toBottomCenterY = toTopCenterY + to.height;

        let toLeftCenterX = to.x;
        let toLeftCenterY = to.y + to.height / 2;
        let toRightCenterX = to.x + to.width;
        let toRightCenterY = toLeftCenterY;

        let curveStartPointX = 0;
        let curveStartPointY = 0;
        let curveEndPointX = 0;
        let curveEndPointY = 0;

        let targetCenter = target.getCenterPoint();
        let toCenter = to.getCenterPoint();

        if (lineContent.startControlPointX <= 0 || lineContent.startControlPointY <= 0 ||
            lineContent.startControlPointX > targetCenter.x + 5000 ||
            lineContent.startControlPointY > targetCenter.y + 5000 ||
            lineContent.endControlPointX <= 0 || lineContent.endControlPointY <= 0 ||
            lineContent.endControlPointX > to.x + 5000 ||
            lineContent.endControlPointY > to.y + 5000) {
            let Xspaceing = (targetCenter.x - toCenter.x);
            let Yspaceing = (targetCenter.y - toCenter.y);
            let marginX = new UiUtil().dip2px(8);
            let marginY = new UiUtil().dip2px(8);
            let minSpaceX = new UiUtil().dip2px(90);
            let minSpaceY = new UiUtil().dip2px(90);
            let horizontalVerticalSpace = new UiUtil().dip2px(40);

            let startControlPointX = 0;
            let startControlPointY = 0;
            let endControlPointX = 0;
            let endControlPointY = 0;

            if (Math.abs(Yspaceing) > minSpaceY && Math.abs(Xspaceing) > horizontalVerticalSpace) {
                if (Yspaceing < 0) { // 下方
                    startControlPointY = (toCenter.y - targetCenter.y) / 2;
                    endControlPointY = (targetCenter.y - toCenter.y) / 2;
                    startControlPointX = 0;
                    endControlPointX = 0;
                } else { // 上方
                    startControlPointY = (toCenter.y - targetCenter.y) / 2;
                    endControlPointY = (targetCenter.y - toCenter.y) / 2;
                    startControlPointX = 0;
                    endControlPointX = 0;
                }
            } else if (Math.abs(Xspaceing) > minSpaceX && Math.abs(Yspaceing) > horizontalVerticalSpace) {
                if (Xspaceing < 0) { // 右
                    startControlPointX = (toCenter.x - targetCenter.x) / 2;
                    endControlPointX = (targetCenter.x - toCenter.x) / 2;

                    startControlPointY = 0;
                    endControlPointY = 0;
                } else { // 左
                    startControlPointX = (toCenter.x - targetCenter.x) / 2;
                    endControlPointX = (targetCenter.x - toCenter.x) / 2;
                    startControlPointY = 0;
                    endControlPointY = 0;
                }
            } else if (Math.abs(Xspaceing) < Math.abs(Yspaceing)) { // 垂直方向
                if (Yspaceing < 0) { // 下方
                    startControlPointY = ((toCenter.y - targetCenter.y) * 0.6);
                    endControlPointY = ((targetCenter.y - toCenter.y) * 0.6);
                    startControlPointX = target.x - (targetCenter.x);
                    endControlPointX = to.x + to.width - (toCenter.x);
                } else { // 上方
                    startControlPointY = ((toCenter.y - targetCenter.y) * 0.6);
                    endControlPointY = ((targetCenter.y - toCenter.y) * 0.6);
                    startControlPointX = target.x - (targetCenter.x);
                    endControlPointX = to.x + to.width - (toCenter.x);
                }
            } else { //水平方向
                if (Xspaceing < 0) { // 右
                    startControlPointX = ((toCenter.x - targetCenter.x) * 0.6);
                    endControlPointX = ((targetCenter.x - toCenter.x) * 0.6);

                    startControlPointY = target.y - (targetCenter.y);
                    endControlPointY = to.y + to.height - (toCenter.y);
                } else { // 左
                    startControlPointX = ((toCenter.x - targetCenter.x) * 0.6);
                    endControlPointX = ((targetCenter.x - toCenter.x) * 0.6);
                    startControlPointY = target.y - (targetCenter.y);
                    endControlPointY = to.y + to.height - (toCenter.y);
                }
            }

            lineContent.startControlPointX = startControlPointX + (targetCenter.x);
            lineContent.startControlPointY = startControlPointY + (targetCenter.y);

            lineContent.endControlPointX = endControlPointX + (toCenter.x);
            lineContent.endControlPointY = endControlPointY + (toCenter.y);

            if (to.type == MindElementType.NODE_CONNECT_LINE && to.lineContent != null &&
                to.lineContent.startControlPointX > 0 && to.lineContent.startControlPointY > 0 &&
                to.lineContent.endControlPointX > 0 && to.lineContent.endControlPointY > 0) {
                if (this.lastClickPoint.isJustSetPoint() && this.lastClickPoint.getId() == to.id &&
                    this.lastClickPoint.getPoint().x > 0 && this.lastClickPoint.getPoint().y > 0) {

                    let start = to.lineContent.startPoint();
                    let end = to.lineContent.endPoint();
                    let space = new UiUtil().dip2px(40);
                    let angle = Util.getCircleDegreesInPoint(start, end);
                    if (this.pointOnLeft(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y - space);
                    } else if (this.pointOnRight(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y + space);
                    } else if (this.pointOnTop(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x - space);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y);
                    } else {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x + space);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y);
                    }
                }
            }
        }
    }

    rightAngleControlPoint(line, target, to) {
        if (target.isEmpty() || to.isEmpty()) {
            return;
        }
        let lineContent = line.lineContent;
        if (lineContent == null) {
            return;
        }

        let targetCenter = target.getCenterPoint();
        let toCenter = to.getCenterPoint();

        if (lineContent.startControlPointX <= 0 || lineContent.startControlPointY <= 0 ||
            lineContent.startControlPointX > targetCenter.x + 5000 ||
            lineContent.startControlPointY > targetCenter.y + 5000 ||
            lineContent.endControlPointX <= 0 || lineContent.endControlPointY <= 0 ||
            lineContent.endControlPointX > to.x + 5000 ||
            lineContent.endControlPointY > to.y + 5000) {
            let Xspaceing = (targetCenter.x - toCenter.x);
            let Yspaceing = (targetCenter.y - toCenter.y);
            let marginX = new UiUtil().dip2px(8);
            let marginY = new UiUtil().dip2px(8);
            let minSpaceX = new UiUtil().dip2px(90);
            let minSpaceY = new UiUtil().dip2px(90);
            let horizontalVerticalSpace = new UiUtil().dip2px(40);

            let startControlPointX = 0;
            let startControlPointY = 0;
            let endControlPointX = 0;
            let endControlPointY = 0;

            if (target.y > to.y && target.y < to.y + to.height ||
                target.y + target.height > to.y && target.y + target.height < to.y + to.height ||
                to.y > target.y && to.y < target.y + target.height ||
                to.y + to.height > target.y && to.y + to.height < target.y + target.height ||
                (targetCenter.y) > to.y && (targetCenter.y) < to.y + to.height ||
                (toCenter.y) > target.y && (toCenter.y) < target.y + target.height) { //水平
                startControlPointY = -(target.height / 2 + minSpaceY);
                endControlPointY = -(to.height / 2 + minSpaceY);
                startControlPointX = 0;
                endControlPointX = 0;
            } else if (target.x > to.x && target.x < to.x + to.width ||
                target.x + target.width > to.x && target.x + target.width < to.x + to.width ||
                to.x > target.x && to.x < target.x + target.width ||
                to.x + to.width > target.x && to.x + to.width < target.x + target.width ||
                (targetCenter.x) > to.x && (targetCenter.x) < to.x + to.width ||
                (toCenter.x) > target.x && (toCenter.x) < target.x + target.width) { //垂直
                startControlPointY = 0;
                endControlPointY = 0;
                startControlPointX = (target.width / 2 + minSpaceX);
                endControlPointX = (to.width / 2 + minSpaceX);
            } else if (Math.abs(Yspaceing) > minSpaceY && Math.abs(Xspaceing) > horizontalVerticalSpace) {
                if (Yspaceing < 0) { // 下方
                    startControlPointY = (toCenter.y - targetCenter.y) / 2;
                    endControlPointY = (targetCenter.y - toCenter.y) / 2;
                    startControlPointX = 0;
                    endControlPointX = 0;
                } else { // 上方
                    startControlPointY = (toCenter.y - targetCenter.y) / 2;
                    endControlPointY = (targetCenter.y - toCenter.y) / 2;
                    startControlPointX = 0;
                    endControlPointX = 0;
                }
            } else if (Math.abs(Xspaceing) > minSpaceX && Math.abs(Yspaceing) > horizontalVerticalSpace) {
                if (Xspaceing < 0) { // 右
                    startControlPointX = (toCenter.x - targetCenter.x) / 2;
                    endControlPointX = (targetCenter.x - toCenter.x) / 2;

                    startControlPointY = 0;
                    endControlPointY = 0;
                } else { // 左
                    startControlPointX = (toCenter.x - targetCenter.x) / 2;
                    endControlPointX = (targetCenter.x - toCenter.x) / 2;
                    startControlPointY = 0;
                    endControlPointY = 0;
                }
            } else if (Math.abs(Xspaceing) < Math.abs(Yspaceing)) { // 垂直方向
                if (Yspaceing < 0) { // 下方
                    startControlPointY = ((toCenter.y - targetCenter.y) * 0.6);
                    endControlPointY = ((targetCenter.y - toCenter.y) * 0.6);
                    startControlPointX = target.x - (targetCenter.x);
                    endControlPointX = to.x + to.width - (toCenter.x);
                } else { // 上方
                    startControlPointY = ((toCenter.y - targetCenter.y) * 0.6);
                    endControlPointY = ((targetCenter.y - toCenter.y) * 0.6);
                    startControlPointX = target.x - (targetCenter.x);
                    endControlPointX = to.x + to.width - (toCenter.x);
                }
            } else { //水平方向
                if (Xspaceing < 0) { // 右
                    startControlPointX = ((toCenter.x - targetCenter.x) * 0.6);
                    endControlPointX = ((targetCenter.x - toCenter.x) * 0.6);

                    startControlPointY = target.y - (targetCenter.y);
                    endControlPointY = to.y + to.height - (toCenter.y);
                } else { // 左
                    startControlPointX = ((toCenter.x - targetCenter.x) * 0.6);
                    endControlPointX = ((targetCenter.x - toCenter.x) * 0.6);
                    startControlPointY = target.y - (targetCenter.y);
                    endControlPointY = to.y + to.height - (toCenter.y);
                }
            }

            lineContent.startControlPointX = startControlPointX + (targetCenter.x);
            lineContent.startControlPointY = startControlPointY + (targetCenter.y);

            lineContent.endControlPointX = endControlPointX + (toCenter.x);
            lineContent.endControlPointY = endControlPointY + (toCenter.y);

            if (to.type == MindElementType.NODE_CONNECT_LINE && to.lineContent != null &&
                to.lineContent.startControlPointX > 0 && to.lineContent.startControlPointY > 0 &&
                to.lineContent.endControlPointX > 0 && to.lineContent.endControlPointY > 0) {
                if (this.lastClickPoint.isJustSetPoint() && this.lastClickPoint.getId() == to.id &&
                    this.lastClickPoint.getPoint().x > 0 && this.lastClickPoint.getPoint().y > 0) {

                    let start = to.lineContent.startPoint();
                    let end = to.lineContent.endPoint();
                    let space = new UiUtil().dip2px(40);
                    let angle = Util.getCircleDegreesInPoint(start, end);
                    if (this.pointOnLeft(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y - space);
                    } else if (this.pointOnRight(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y + space);
                    } else if (this.pointOnTop(angle)) {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x - space);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y);
                    } else {
                        lineContent.endControlPointX = (this.lastClickPoint.getPoint().x + space);
                        lineContent.endControlPointY = (this.lastClickPoint.getPoint().y);
                    }
                }
            }
        }
    }

    getNodeById(id) {
        let node = this.mainMindNodeUnit.getNodeById(id);
        if (!node.isEmpty()) {
            return node;
        }

        let freeNodesLength = this.freeNodes.length
        for (let index = 0; index < freeNodesLength; index++) {
            let unit = this.freeNodes[index];
            node = unit.getNodeById(id);
            if (!node.isEmpty()) {
                return node;
            }
        }

        node = this.doubleBubbleMindNodeUnit.getNodeById(id);
        if (!node.isEmpty()) {
            return node;
        }
        if (node.isEmpty() && this.nodeConnectLineDataDict.containsKey(id)) {
            return new LineMindTypeNode(this.nodeConnectLineDataDict.get(id));
        }
        if (node.isEmpty()) {
            return new LineMindTypeNode(this.timeMindTypeNodeUnit.getNodeById(id));
        }
        return node;
    }

    pointOnLeft(angle) {
        return angle >= 135 && angle <= 225;
    }

    pointOnRight(angle) {
        return (angle >= 315 && angle <= 360) || angle >= 0 && angle <= 45;
    }

    pointOnTop(angle) {
        return angle >= 225 && angle <= 315;
    }

    pointOnBottom(angle) {
        return angle >= 45 && angle <= 135;
    }
}

export default NodeConnectLineCalcul